import React from 'react'
import TeacherDash from '../../Components/TeacherComponents/TeacherDash/TeacherDash'
import NotesShares from '../../Components/TeacherComponents/NotesShare/NotesShares'

function NotesShare() {
  return (
    <div>
        <TeacherDash>
            <NotesShares/>
        </TeacherDash>
    </div>
  )
}

export default NotesShare